"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "StrategyLogo___StyledSvg",
  componentId: "sc-1e4abva-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function StrategyLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.528 23.484c0 .956-.541 2.027-1.405 3.125L13.938 11.426c2.674-1.318 4.792-3.2 6.078-4.547 1.934 2.026 5.726 5.297 10.512 5.971v10.635zM20.016 33.752C15.641 31.298 9.504 26.73 9.504 23.484V12.849c.256-.037.496-.107.746-.158l16.427 16.427c-2.043 1.779-4.553 3.454-6.661 4.634zM32.28 9.468c-6.027 0-10.817-6.246-10.864-6.311-.662-.876-2.137-.876-2.8 0-.047.065-4.837 6.31-10.864 6.31-.967 0-1.752.786-1.752 1.753v12.264c0 6.673 11.849 13.103 13.2 13.814a1.748 1.748 0 001.633 0c1.35-.71 13.2-7.14 13.2-13.814V11.22c0-.967-.786-1.752-1.753-1.752z",
    fill: "currentColor"
  }));
}

var _default = StrategyLogo;
exports["default"] = _default;